import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosAtribuicao from "../../servicos/servicos-atribuicao";
import servicosColaborador from "../../servicos/servicos-colaborador";
import servicosMotivo from "../../servicos/servicos-motivo";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";
import AuthContext from "../../servicos/autorizacao/AuthContex";
import { useContext } from "react";
import Edit from "../../img/svgs/Edit";
import Delete from "../../img/svgs/Delete";
import Salvar from "../../img/svgs/Salvar";
import Cancel from "../../img/svgs/Cancel";
import Spinner from "../components/Spinner";
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from "@mui/material";
import ShareIcon from '@mui/icons-material/Share';
import ExcelJS from 'exceljs';
import moment from "moment";


const ListAtribuicaoMilhas = () => {
  const { user } = useContext(AuthContext);
  const [atribuicoes, setAtribuicoes] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [motivos, setMotivos] = useState([]);
  const [editado, setEditado] = useState(false)
  const [deletado, setDeletado] = useState(false)
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);
  const [colaborador, setColaborador] = useState();
  const [motivo, setMotivo] = useState();
  const id_colaborador = useRef();
  const id_motivo = useRef();
  const [showConfirmacao, setShowConfirmacao] = useState(false);
  const [showExcluir, setShowExcluir] = useState(false);
  const [idExcluir, setIdExcluir] = useState();
  const [idEdit, setIdEdit] = useState();
  const [listaFiltrada, setListaFiltrada] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);



  const handleClose = () => setShow(false);

  const autorizado = user.role === 'root' || user.role === 'admin';

  useEffect(() => {
    function getDados() {
      servicosAtribuicao.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setAtribuicoes(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [deletado, editado]);

  useEffect(() => {
    function getDados() {
      servicosColaborador.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setColaboradores(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [editado, deletado]);

  useEffect(() => {
    function getDados() {
      servicosMotivo.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setMotivos(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [editado, deletado]);

  const editarAtribuicao = (colaboradorId, motivoId) => {
    setEditado(false);
    const data = {
      "id_colaborador": colaboradorId,
      "id_motivo": motivoId
    }

    servicosAtribuicao.editar(idEdit, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success("Atribuição alterada com sucesso!", {
          theme: "colored",
        });
        setShowConfirmacao(false);
      }
    }).catch(error => {
      toast.error("Não foi possível alterar a atribuição!", {
        theme: "colored"
      });
      setShowConfirmacao(false);
      console.log(error);
    })
    handleClose()
  }

  const deletarAtribuicao = () => {
    setDeletado(false)
    servicosAtribuicao.deletar(idExcluir).then(response => {
      if (response.status === 200) {
        setDeletado(true);
        toast.success("Atribuição deletada com sucesso!", {
          theme: "colored",
        });
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível deletar a atribuição!", {
        theme: "colored"
      });
    })
    setShowExcluir(false);
  }

  const handleCloseConfirmacao = () => {
    setShowConfirmacao(false);
  }
  const handleCloseExcluir = () => {
    setShowExcluir(false);
  }

  const handleShowConfirmacao = (id) => {
    setShow(false);
    setShowConfirmacao(true);
    setIdExcluir(id);
  }
  const handleShowExcluir = (id) => {
    setShowExcluir(true);
    setIdExcluir(id);
  }

  const handlePesquisa = (e) => {
    const pesquisa = e.target.value;
    let listaAtualizada = [];
    if (pesquisa !== "") {
      listaAtualizada = atribuicoes.filter((item) => {
        return String(item.Colaborador[0].nome).toLowerCase().indexOf(pesquisa.toLowerCase()) !== -1;
      })
      setListaFiltrada(listaAtualizada);
    } else {
      setListaFiltrada(atribuicoes);
    }

  }

  const onRowsSelectionHandler = (ids) => {
    const selectedRowsData = ids.map((item) => atribuicoes.find((row) => row.id_milhas === item.id_milhas));
    setSelectedRows(selectedRowsData);
  };

  const actions = [
    { icon: <ShareIcon />, name: 'Exportar Excel' },
  ];

  const handleActionClick = (actionName) => {
    switch (actionName) {
      case 'Exportar Excel':
        handleExportToExcel();
        break;
      default:
        break;
    }
  };

  const handleExportToExcel = () => {
    if (selectedRows.length < 1) {
      toast.warning('Por favor selecione pelo menos 1 atribuição')
    } else {
      const selectedRowsIds = selectedRows.map((rowIndex) => rowIndex.id_milhas);
      const selectedAtribuicoes = atribuicoes.filter((atribuicao) => selectedRowsIds.includes(atribuicao.id_milhas));

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Atribuições');

      columnsAtribuicao.forEach((column, index) => {
        if (column.field !== 'delete' && column.field !== 'edit') {
          worksheet.getColumn(index + 1).header = column.headerName;
          worksheet.getColumn(index + 1).key = column.field;
          worksheet.getColumn(index + 1).width = 10;
        }

      });

      selectedAtribuicoes.forEach((atribuicao) => {
        const rowData = {};
        columnsAtribuicao.forEach((column) => {
          if (column.field === 'id_milhas') {
            rowData[column.field] = atribuicao.id_milhas;
          } else if (column.field === 'Colaborador[0].nome') {
            rowData[column.field] = atribuicao.Colaborador[0].nome
          } else if (column.field === 'Motivo[0].descricao') {
            rowData[column.field] = atribuicao.Motivo[0].descricao
          } else if (column.field === 'Motivo[0].qtd_milhas') {
            rowData[column.field] = atribuicao.Motivo[0].qtd_milhas
          } else if (column.field === 'data') {
            rowData[column.field] = formatData(atribuicao.data)
          }
        });
        worksheet.addRow(rowData);
      });

      const saveOptions = {
        filename: 'atribuicoes_internas.xlsx',
        useStyles: true,
        useSharedStrings: true
      };

      workbook.xlsx.writeBuffer().then((buffer) => {
        const data = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(data);
        const link = document.createElement('a');
        link.href = url;
        link.download = saveOptions.filename;
        link.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
        }, 100);
      });
    }
  };

  const ModalConfirmacao = (props) => {
    return <>
      <div >
        <Modal className="modal-confirmacao" show={showConfirmacao} onHide={handleCloseConfirmacao}>
          <Modal.Body className="">
            <span>Você deseja realmente alterar a  atribuicão?</span> <br />
          </Modal.Body>
          <Modal.Footer >
            <button type="button" className="border-1 w-25 btn-icones p-1 rounded" onClick={() => editarAtribuicao(props.id_colaborador, props.id_motivo, props.id_edit)}><Salvar /><span> Salvar</span></button>
            <button type="button" className="border-1 w-25 btn-icones p-1  rounded" onClick={handleCloseConfirmacao}><Cancel /><span> Cancelar</span></button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  }

  const ModalExcluir = () => {
    return <>
      <div >
        <Modal className="modal-confirmacao" show={showExcluir} onHide={handleCloseExcluir}>
          <Modal.Body className="">
            <span>Você deseja realmente deletar a  atribuicão?</span> <br />
          </Modal.Body>
          <Modal.Footer >
            <button type="button" className="border-1 w-25 p-1 rounded btn-icones text-light" onClick={deletarAtribuicao}><Salvar /> <span className="text-dark">Confirmar</span></button>
            <button type="button" className="btn-icones w-25 border-1 p-1 rounded text-light" onClick={handleCloseExcluir}><Cancel /> <span className="text-dark">Voltar</span></button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  }

  const handleShow = (atribuicao) => {
    const id = atribuicao.id_milhas;
    setIdEdit(id);
    setColaborador(atribuicao.Colaborador[0]);
    setMotivo(atribuicao.Motivo[0]);
    setShow(true);
  }

  const formatData = ( data ) => {
    const dataf = moment(data);
    return dataf.format('DD/MM/YYYY')
  }

  const SelectColaboradores = () => {
    if (colaboradores === null) {
      return <>Carregando lista de colaboradores</>
    }
    return (
      <>
        <Form.Field className="mx-5 mt-4">
          <label htmlFor="id_colaborador" className="form-label label-texto">Colaborador</label>
          <select className="input-cadastro" name="id_colaborador" ref={id_colaborador} aria-label="" defaultValue={colaborador.id_colaborador}>
            <option value={0}>Selecione</option>
            {colaboradores.map((item) => {
              const id = item.id_colaborador;
              return <option key={id} value={id}>{item.nome}</option>
            })}
          </select>
        </Form.Field>
      </>
    )
  }
  const SelectMotivos = () => {
    if (motivos === null) {
      return <>Carregando lista de motivos</>
    }
    return (
      <>
        <Form.Field className="mx-5 mt-4">
          <label htmlFor="id_motivo" className="form-label label-texto">Motivo</label>
          <select className="input-cadastro" ref={id_motivo} name="id_motivo" aria-label="" defaultValue={motivo.id_motivo}>
            <option value={0}>Selecione</option>
            {motivos.map((item) => {
              const id = item.id_motivo;
              return <option key={id} value={id}>{item.descricao}</option>
            })}
          </select>
        </Form.Field>
      </>
    )
  }
  const ModalEditar = () => {
    return <>
      <Modal className="modal-atribuicoes" show={show} onHide={handleClose}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  <SelectColaboradores />
                  <SelectMotivos />
                  <Form.Field className=" mt-4 text-center w-100">
                    <button className="w-25 me-1 btn-icones border-1 p-1 rounded" onClick={handleShowConfirmacao}>
                      <Salvar /> Salvar
                    </button>
                    <button className="btn-icones w-25 border-1 p-1 rounded" onClick={handleClose}>
                      <Cancel /> <span>Cancelar</span>
                    </button>

                  </Form.Field>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }

  const SpeedDialShared = () => {
    return (
      <Box sx={{ height: 100, transform: 'translateZ(0px)', flexGrow: 1 }}>
        <SpeedDial
          ariaLabel="SpeedDial"
          sx={{ position: 'absolute', bottom: 38, right: 16, }}
          icon={<SpeedDialIcon />}
          FabProps={{
            sx: {
              bgcolor: '#753BBD',
              '&:hover': {
                bgcolor: '#753BBD',
              }
            }
          }}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={() => handleActionClick(action.name)}
            />
          ))}
        </SpeedDial>
      </Box>
    )
  }

  const columnsAtribuicao = [
    {
      field: "data",
      headerName: "Data Atribuição",
      valueGetter: (params) => {
        let aux = String(params.value).split("-");
        let ano = aux[0];
        let mes = aux[1];
        let dia = aux[2];
        let dataFormatada = `${dia}-${mes}-${ano}`;
        return dataFormatada;
      }
    },
    {
      field: "Colaborador[0].nome",
      headerName: "Colaborador",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.row.Colaborador[0].nome
      }
    },
    {
      field: "Motivo[0].descricao",
      headerName: "Motivo",
      width: 200,
      editable: true,
      valueGetter: (params) => {
        return params.row.Motivo[0].descricao
      }
    },
    {
      field: "Motivo[0].qtd_milhas",
      headerName: "Qtd Milhas",
      width: 80,
      editable: true,
      valueGetter: (params) => {
        return params.row.Motivo[0].qtd_milhas
      }
    },
    
    {
      field: "delete",
      headerName: <span className="ms-4">Excluir </span>,
      align: "center",
      sortable: false,
      renderCell: (params) => {
        if (autorizado) {
          return <button className="border-0 text-light rounded p-1 btn-icones" onClick={() => handleShowExcluir(params.row.id_milhas)} ><Delete /></button>;
        } else {
          return <button className="border-0 text-light rounded p-1 btn-icones" disabled><Delete /></button>;
        }

      }
    },
    {
      field: "edit",
      headerName: <span className="ms-3">Editar</span>,
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return <button className="border-0 text-light rounded p-1 btn-icones" onClick={() => handleShow(params.row)} ><Edit /></button>;
      }
    }
  ];


  return (
    <>
      <NavMenu />
      <ModalExcluir />
      <ToastContainer />
      <ModalConfirmacao className="modal-confirmacao"
        id_colaborador={id_colaborador?.current?.value}
        id_motivo={id_motivo?.current?.value}
      />

      <div className="d-flex col container">
        <div className="w-25">
          <MenuLateral />
        </div>
        {atribuicoes.length === 0 ?
          <div className="w-75 d-flex justify-content-center align-items-center"><Spinner mensagem="Carregando lista de atribuições..." /> </div> :
          <div className="w-75 tabelas-gerenciais">
            <ModalEditar />

            <Box sx={{ height: 650, width: 750, marginTop: 1 }}>
              <Box>
                <input
                  className="p-1 mb-2 border-1 rounded-5"
                  type="text"
                  id="pesquisa"
                  placeholder=" Pesquise pelo nome"
                  onChange={handlePesquisa}
                />
                
              </Box>
              <DataGrid
                localeText={localizedTextsMap}
                rows={listaFiltrada.length > 0 ? listaFiltrada : atribuicoes}
                columns={columnsAtribuicao}
                pageSize={10}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                getRowId={(row) => row.id_milhas}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                }
                checkboxSelection
                onSelectionModelChange={(ids) => {
                  const selectedIDs = new Set(ids);
                  const selectedRowData = atribuicoes.filter((row) =>
                    selectedIDs.has(row.id_milhas)
                  )
                  onRowsSelectionHandler(selectedRowData);
                }}
              />
              <Box mt={5}>
                <SpeedDialShared />
              </Box>
            </Box>
          </div>

        }

      </div>
    </>
  );
};

export default ListAtribuicaoMilhas;